// Modules
import axios from "axios";
import { useEffect, useState } from "react";
import { parsePath, useNavigate, useParams } from "react-router-dom";
import uuid from "react-uuid";
import { useSelector } from "react-redux";

// CSS
import '_Asset/css/Admin/Page/admin.css'

// API
import { MemApi, MemSgApi, MemRolesApi, MemSignupApi } from "_Route/Api";


// [2022.12.14 기준 - AdMemDt(회원 상세 관리) 페이지 사용 X]
const AdMemDt = () => {

  // Using Hooks
  const params = useParams();
  const navigate = useNavigate();

  const curType = params.id === 'add' ? '등록' : '수정'; // 관리 Type
  const curScore = params.id === 'add' ? 200 : 300;
  // const curScore = params.id === 'add' ? 200 : 300; // 현재 타입에 따른 필요 권한 점수
  const useGroup = ['미사용', '사용'];

  const sessionID = localStorage.getItem('memSessionID')
  const userScore = useSelector(state => state.authorityAcc.access_score);
  const master = useSelector(state => state.authorityAcc.master);
  // const userRoles = useSelector(state => state.authorityAcc.roles);

  const [info, setInfo] = useState({
    uid: params.id,
    email: '',
    name: '',
    company_name: '',
    phone_number: '',
    ip: '',
    use: 1,
    company_domain: '',
    ...(curType === '수정' ? { roles: '', access_score: ''} : { pass: '', rePass: ''}),
    approve_spec_status: 0,
    approve_ap_status: 0,
  })
  const [rolesList, setRolesList] = useState([])
  const { name, company_name, phone_number, ip, use, company_domain, roles, access_score } = info;
  

  /*========================================================================
  * Input onChange Func
  ========================================================================*/
  const onChange = (e) => {
    const { name, value } = e.target;

    if (name === 'roles') {
      setInfo({...info, [name]: [value]});
    } else {
      setInfo({...info, [name]: value});
    }
  }


  /*========================================================================
  * Set Current Account List
  ========================================================================*/
  const onJSON = (VALUES) => {
    try {
      return JSON.parse(VALUES)
    }
    catch {
      return VALUES
    }
  }

  useEffect(() => {
    axios.get(MemRolesApi, {
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
    })
    .then(res => {
      // console.log(res.data.result)
      setRolesList(res.data.result)
    })
    .catch(err => {
      console.error(err, "GET Member roles list Error...");
    })

    axios.get(MemSgApi, {
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      params: {
        uid: params.id
      }
    })
    .then(res => {
      const curMem = res.data.result[0];
      if(curMem === undefined && params.id !== 'add') {
        navigate('/404');
      }
      else {
        if (curType === '수정') {
          Object.entries(curMem).map(key => {
            const KEYS = key[0];
            const VALUES = key[1];
            
            if(Object.keys(info).includes(KEYS)) {
              info[KEYS] = VALUES

              if (KEYS === 'roles') {
                info[KEYS] = onJSON(VALUES)
              }
            }
          })
          setInfo({...info})
        }
      }
    })
    .catch(err => {
      console.error(err, "GET Account Data Error...");
    })
  }, [])


  /*========================================================================
  * Member POST / PUT / DELETE
  ========================================================================*/
  const PostACC = () => { // Member POST
    axios({
      url: MemSignupApi,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      data: info
    })
    .then(res => {
      alert(`회원 계정 등록${master === 1 ? '' : ' 요청'}을 완료하였습니다.`)
      navigate('/admin/member-mgt/list')
    })
    .catch(err => {
      console.error(err, "Member POST Error...")
      const errMsg = err.response.data.message
      if (errMsg) { alert(errMsg) }
    })
  }

  const UpdateACC = () => { // Member Update
    info.roles = JSON.stringify(info.roles)
    axios({
      url: MemApi,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      data: info
    })
    .then(res => {
      alert(`회원 계정 수정${master === 1 ? '' : ' 요청'}을 완료하였습니다.`)
      navigate('/admin/member-mgt/list')
    })
    .catch(err => {
      console.error(err, "Member PUT Error..")
      const errMsg = err.response.data.message
      if (errMsg) { alert(errMsg) }
    })
  }

  const DeleteACC = () => { // Member Delete
    axios({
      url: MemApi,
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      data: {
        uid: params.id,
        approve_spec_status: 0,
        approve_ap_status: 0,
      }
    })
    .then(res => {
      alert(`회원 계정 삭제${master === 1 ? '를' : ' 요청을'} 완료하였습니다.`)
      navigate('/admin/member-mgt/list')
    })
    .catch(err => {
      console.error(err, "Member DELETE Error..")
      const errMsg = err.response.data.message
      if (errMsg) { alert(errMsg) }
    })
  }

  
  return (
    <>
      <div className="adContTitGroup">
        <h2>회원 {curType}</h2>
        <p>Home / 관리자 회원 관리 / 회원 {curType}</p>
      </div>

      <div className="adContArea detail">
        <fieldset className="left">
          <legend>회원 {curType}</legend>

          {/* 사용여부 [use] */}
          <div className="fieldGroup row">
            <label>사용여부<span className="redTxt">*</span></label>

            <div className="field">
              {useGroup.map((item, i) =>
                <div className="checkGroup" key={i}>
                  <input type="radio" className="check sm blue" id={`use_${i}`} onChange={() => setInfo({...info, use: i})} checked={use === i}/>
                  <label htmlFor={`use_${i}`}></label>

                  <label htmlFor={`use_${i}`}>{item}</label>
                </div>
              )}
            </div>
          </div>

          {/* 회사명 [company_name] */}
          <div className="fieldGroup row">
            <label>회사명<span className="redTxt">*</span></label>

            <div className="field">
              <input type="text" className="input md round_10" name="company_name" onChange={(e) => onChange(e)} value={company_name} placeholder="제목을 입력해주세요." />
            </div>
          </div>

          {/* 회사 도메인 [company_domain] */}
          <div className="fieldGroup row">
            <label>회사 도메인<span className="redTxt">*</span></label>

            <div className="field">
              <input type="text" className="input md round_10" name="company_domain" onChange={(e) => onChange(e)} value={company_domain} placeholder="회사 도메인을 입력해주세요." />
            </div>
          </div>

            {
              curType === '등록' &&
              <>
              {/* 이메일 [email] */}
              <div className="fieldGroup row">
                <label>이메일<span className="redTxt">*</span></label>

                <div className="field msg">
                  <input type="text" className="input md round_10" name="email" onChange={(e) => onChange(e)} placeholder="이메일을 입력해주세요." />
                </div>
              </div>

              {/* 비밀번호 [pass] */}
              <div className="fieldGroup row">
                <label>비밀번호<span className="redTxt">*</span></label>

                <div className="field msg">
                  <input type="password" className="input md round_10" name="pass" onChange={(e) => onChange(e)} placeholder="비밀번호를 입력해주세요." />
                </div>
              </div>

              {/* 비밀번호 확인 [rePass] */}
              <div className="fieldGroup row">
                <label>비밀번호 확인<span className="redTxt">*</span></label>

                <div className="field msg">
                  <input type="password" className="input md round_10" name="rePass" onChange={(e) => onChange(e)} placeholder="비밀번호를 다시 입력해주세요." />
                </div>
              </div>
              </>
            }

          {/* 이름 [name] */}
          <div className="fieldGroup row">
            <label>이름<span className="redTxt">*</span></label>

            <div className="field">
              <input type="text" className="input md round_10" name="name" onChange={(e) => onChange(e)} value={name} placeholder="한글 이름을 입력해주세요." />
            </div>
          </div>

          {/* 휴대폰 번호 [phone_number] */}
          <div className="fieldGroup row">
            <label>휴대폰 번호<span className="redTxt">*</span></label>

            <div className="field">
              <input type="text" className="input md round_10" name="phone_number" onChange={(e) => setInfo({...info, phone_number: e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')})} value={phone_number} placeholder="휴대폰 번호를 입력해주세요." />
            </div>
            <p className="fieldTxt info">* 휴대폰 번호는 -(하이픈)을 제외하고 숫자만 입력해주세요.</p>
          </div>

          {
            curType === '수정' &&
            <>
            {/* 회원 권한 [roles] */}
            <div className="fieldGroup row">
              <label>회원 권한<span className="redTxt">*</span></label>

              <div className="field">
                <select className="select md round_10 type_1" name="roles" onChange={(e) => onChange(e)} key={uuid()} defaultValue={roles[0]} disabled={userScore === 300 ? false : true}>
                  {rolesList.map((list, i) =>
                    <option value={list.acc_grade} key={i}>{list.acc_grade}</option>
                  )}
                </select>
              </div>
            </div>

            {/* 권한 점수 [access_score] */}
            <div className="fieldGroup row">
              <label>권한 점수<span className="redTxt">*</span></label>

              <div className="field">
                <select className="select md round_10 type_1" name="access_score" onChange={(e) => onChange(e)} key={uuid()} defaultValue={access_score} disabled={userScore === 300 ? false : true}>
                  <option value={100}>100 (Readonly)</option>
                  <option value={200}>200 (Add)</option>
                  <option value={300}>300 (Modify/Delete)</option>
                </select>
              </div>
            </div>
            </>
          }
        </fieldset>

        <div className="btnArea">
          {
            userScore >= curScore &&
            <button type="button" className="btn sm sfrtBlue round_10" onClick={curType === '수정' ? UpdateACC : PostACC}>{curType}{master === 1 ? '' : ' 요청'}</button>
          }
          <button type="button" className="btn sm blue_edge round_10" onClick={() => navigate('/admin/member-mgt/list')}>취소</button>
          {curType === '수정' && userScore >= 300 && <button type="button" className="btn sm red round_10" onClick={() => {if(window.confirm(`정말 선택하신 계정을 삭제${master === 1 ? '' : ' 요청'}하시겠습니까?`)) DeleteACC() }}>{`삭제${master === 1 ? '' : ' 요청'}`}</button>}
        </div>
      </div>
    </>
  )
}

export default AdMemDt;